import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AfectoIgv } from 'src/app/Models/afectoigv/afecto-igv';
import { AlertComponent } from 'src/app/Components/objects/alert/alert/alert.component';
import { LoadingComponent } from 'src/app/Components/objects/loading/loading.component';
import { InfoComponent } from 'src/app/Components/objects/info/info/info.component';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-dialog-afecto-igv',
  templateUrl: './dialog-afecto-igv.component.html',
  styleUrls: ['./dialog-afecto-igv.component.css']
})
export class DialogAfectoIgvComponent implements OnInit {

  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;

  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public isShow: boolean = false;
  public pagina: number = 0;
  public total:number=0;
  public afectos: AfectoIgv[] = [];
  public afecto:AfectoIgv = new AfectoIgv();
  public isEdit: boolean = false;
  public funcion: Function = null;
  public pgafecto: any;
  public adddescripcion: boolean = false;
  public search = '';
  constructor(private data: DataService) { }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
      this.funcion = affterfunction;
      this.isShow = true;
      this.showTab(1);
      setTimeout(() => {
          this.btnshow.nativeElement.click();
          this.GetData();
      }, 10);
  }

  GetData() {
      this.loading.show("cargando..");
      this.afectos=[];
      this.data.select(this.data.api.afectoigv, 'like', this.search).subscribe(r => {
          this.loading.hide();
          if (this.data.Exists(r[0].id)) {
              this.afectos = r;
              this.total= this.afectos.length;
          }
      }, e => { this.loading.hide(); this.info.error(e, () => { this.showTab(1) }) })
  }
  showTab(i) {
      this.pagina = i;
  }

  seleccion(i){
    this.afecto = this.afectos[i];
    this.close();
  }

  close() {
      this.btnclose.nativeElement.click();
      setTimeout(() => {
          if (this.funcion != null) {
              this.funcion();
          }
      }, 10);
  }

}
